<template lang="pug">
  .main
    Hero(:content="heroContent")
    .container
      div(v-for="(content, index) in contentData", v-scroll-reveal={origin: 'right', delay: 200})
        h3(v-if="index !== 'des'") {{ index }}
        div(v-html="content")
</template>

<script>
import Datas from '@/../static/json/volunteer.json'
import Hero from '@/components/Hero'

export default {
  components: {
    Hero
  },
  data () {
    return {
      heroContent: {
        title: '志工招募。',
        imageNo: 4
      },
      contentData: Datas
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Recruit.vue